import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/home/ds/Projects/personal/vue3-boilerplate/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/ds/Projects/personal/vue3-boilerplate/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "vue3-boilerplate"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/46.22272dfa.css",
    "revision": null
  },
  {
    "url": "/css/about.22272dfa.css",
    "revision": null
  },
  {
    "url": "/css/app.eba26e67.css",
    "revision": null
  },
  {
    "url": "/css/chunk-vendors.a11203b3.css",
    "revision": null
  },
  {
    "url": "/js/46.dc57ec96.js",
    "revision": null
  },
  {
    "url": "/js/about.3d608937.js",
    "revision": null
  },
  {
    "url": "/js/app.5a921731.js",
    "revision": null
  },
  {
    "url": "/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {});








